import { useState, useRef } from 'react';
import { Card, Typography, Box, TextField, Button } from '@mui/material';

import useAppStore from '@/store/app';
import { useRouteLoaderData } from 'react-router-dom';
import useTenantMutation from '@/hooks/useTenantMutation';

const themeDefaults = {
  palette: {
    primary: {
      main: '#18CC63',
    },
    secondary: {
      main: '#19BB5D',
    },
  },
};

const colorDescriptions = {
  primary: {
    title: 'Primärfarbe',
    description:
      'Diese Farbe wird für Hauptaktionen und hervorgehobene Elemente verwendet.',
  },
  secondary: {
    title: 'Sekundärfarbe',
    description:
      'Diese Farbe wird für sekundäre Aktionen und weniger dominante Elemente verwendet.',
  },
};

export default function ThemeForm() {
  const { client, config } = useRouteLoaderData('auth');
  const { styles, setStyles } = useAppStore();

  const initialStylesRef = useRef(styles || themeDefaults);
  const { mutateAsync: updateConfig } = useTenantMutation(
    'deployment',
    `${client.deployment._id}`,
  );

  const [themeColors, setThemeColors] = useState(styles || themeDefaults);

  const handleColorChange = (category, value) => {
    const updatedTheme = {
      ...themeColors,
      palette: {
        ...themeColors.palette,
        [category]: { main: value },
      },
    };
    setThemeColors(updatedTheme);
    setStyles(updatedTheme);
  };

  const handleDiscard = () => {
    setThemeColors(initialStylesRef.current);
    setStyles(initialStylesRef.current);
  };

  const handleSave = async () => {
    await updateConfig({
      config: {
        ...config,
        styles: themeColors,
      },
    });
    initialStylesRef.current = themeColors;
  };

  return (
    <Card sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Theme Farben
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {Object.entries(themeColors.palette).map(([key, value]) =>
          colorDescriptions[key] ? (
            <Box
              key={key}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
            >
              <Typography variant="subtitle1">
                {colorDescriptions[key].title}
              </Typography>
              <Typography variant="body2">
                {colorDescriptions[key].description}
              </Typography>
              <TextField
                type="color"
                value={value.main}
                onChange={(e) => handleColorChange(key, e.target.value)}
                sx={{ width: '50px', height: '40px' }}
              />
            </Box>
          ) : null,
        )}
      </Box>

      <Box sx={{ mt: 4 }}>
        <Button variant="outlined" onClick={handleDiscard} sx={{ mr: 2 }}>
          Verwerfen
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Speichern
        </Button>
      </Box>
    </Card>
  );
}
